export enum WorkPeriodType {
  Weekly = "WEEKLY",
  Other = "OTHER",
}
